/**
 * Replace spaces in nested "functions"
 * @param {String} input
 * @returns {String}
 */
const replaceNestedSpaces = (input) => {
  let level = -1;
  let timeline = 0;
  let result = "";

  for (const letter of input) {
    let character = letter;

    if (character === "(") {
      ++level;
    }
    if (character === ")") {
      --level;
    }

    if (character === "[") {
      ++timeline;
    }
    if (character === "]") {
      --timeline;
    }

    if (character === ",") {
      switch (level) {
        case 1:
          character = "▏";
          break;

        case 2:
          character = "▌";
          break;

        default:
          if (timeline === 1) {
            character = "╚";
          } else {
            character = "╳";
          }
          break;
      }
    }

    if (character === " ") {
      switch (level) {
        case 0:
          character = "▁";
          break;

        case 1:
          character = "▂";
          break;

        case 2:
          character = "▃";
          break;

        default:
          character = "▥";
          break;
      }
    }

    result += character;
  }

  return result;
};

export default replaceNestedSpaces;
